import React from 'react';
import { useSelector } from 'react-redux';
import QuestionTile from '../QuestionTile/QuestionTile.js';
import styles from './HomeBlock.module.css';

function HomeBlock() {
  const modelName = useSelector((state) => state.shared.model_name);

  const questionsMapping = {
    'AE Academic Advisor': [
      "Who is my academic advisor?",
      "How do I get a Research Permit?",
      "What AE courses are available next semester?",
      "When can I start registering for classes?",
    ],
    'IE Academic Advisor': [
      'Can I double count courses towards my major and a minor?',
      'What is the minimum GPA required to graduate with a BS IE?',
      'How do I register when an ISyE class is full?',
      'How do I apply to graduate?',
    ],
  };

  // Get the questions based on the modelName, default to an empty array if modelName is not found
  const questions = questionsMapping[modelName] || [];

  return (
    <div className={styles.layout}>
      <p className={styles.tagline}>Welcome to AVA Advisor</p>
      <div className={styles.question_block}>
        {questions.map((question, index) => (
          <div key={index}>
            <QuestionTile question={question} />
          </div>
        ))}
      </div>
    </div>
  );
}

export default HomeBlock;
